// Every page lives under a language-specific Homepage obj, which carries the
// per-language settings (menu language, mail wording, success message). Walk up
// from the current page to find it.
export function findHomepage(page) {
  if (!page) return null;
  if (page.objClass() === 'Homepage') return page;
  const parent = page.parent();
  if (!parent) return null;
  return findHomepage(parent);
}
